<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container">
                <div class="modal-body">
                    <div class="form-floating mb-2">
                        <input type="text" class="form-control" id="client-name" v-model="formData.name" placeholder="Введите имя пользователя">
                        <label for="client-name">Имя пользователя</label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" id="is_statistics_enabled" v-model="formData.auto_create_license">
                        <label class="form-check-label" for="is_statistics_enabled">
                            Сбор статистики показов
                        </label>
                    </div>
                    <div class="mb-3">
                        <label for="client-comment" class="form-label">Комментарий</label>
                        <textarea class="form-control" id="client-comment" rows="3" v-model="formData.comment"></textarea>
                    </div>
                </div>
                <div>
                    <button v-if="createElement" class="btn btn-success m-1" v-on:click="create()">
                        Создать
                    </button>
                    <button v-else class="btn btn-success m-1" v-on:click="edit()">
                        Изменить
                    </button>
                    <button class="btn btn-danger" v-on:click="closeModal">
                        Отмена
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "ClientModal",
    props: {
        requestUrl: {
            type: String,
            default: 'empty'
        },
        createElement: {
            type: Boolean,
            default: false
        },
        id: {
            type: Number,
            default: 0
        },
        view_data: {
            type: Object,
            default: {}
        }
    },
    emits: ["insert", "closeModal", "edit"],
    data: function () {
        return {
            formData: {
                name: '',
                auto_create_license: false,
                comment: ''
            }
        }
    },
    methods: {
        create: function () {
            this.$emit('insert', this.formData);
        },
        closeModal: function() {
            this.$emit('closeModal');
        },
        edit: function () {
            this.$emit('edit', this.formData, this.id);
        }
    },
    mounted() {
        this.formData = this.view_data;
        this.formData.auto_create_license = this.formData.auto_create_license===1;
    }
}
</script>

<style scoped>
    .form-check {
        display: block !important;
    }
</style>
